/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/* eslint-disable filenames/match-exported */

/**
 * A module aggregating formating.
 * @module utilities/formats
 */
"use strict";

/** @requires utilities/formats/number */

var number = require("./number");

/** @requires utilities/formats/shortUUID */
var shortUUID = require("./shortUUID");

/** @requires utilities/formats/url */
var url = require("./url");

/** @requires utilities/formats/stringToReact */
var stringToReact = require("./stringToReact");

// Common exports.
var moduleExports = {
  number: number,
  shortUUID: shortUUID,
  stringToReact: stringToReact,
  url: url
};

// Backend exports.
if (!process.browser) {
  /** @requires utilities/formats/xlsx */
  var xlsx = require("./xlsx");

  moduleExports.xlsx = xlsx;
}

module.exports = moduleExports;


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/formats/index.js
// module id = 871
// module chunks = 6